<template>
    <div class="section-block record-block">
        <div class="section-title">案件笔录信息</div>
        <el-scrollbar class="record-scrollbar" v-loading="recordLoading">
            <div v-if="recordList.length" class="record-list">
                <div
                    v-for="(item, index) in recordList"
                    :key="item.id || index"
                    class="record-item"
                >
                    <div class="record-icon-wrap">
                        <img src="@/assets/images/Investigation/transcript.png" alt="笔录" class="record-icon" />
                    </div>
                  <div class="record-content">
                    <div class="record-title">
                      <p v-for="item in formatFile(item.fileUrl)" :key="item.name">{{ item.name || '-' }}</p>
                    </div>
                    <div class="record-body">
                      <div class="record-remark" >笔录类型: {{ item.typeName }}</div>
<!--                      <div class="record-remark" >被调查人: {{ item.respondentName || '-' }}</div>-->
<!--                      <div class="record-remark">调查时间: {{ item.surveyTime || '-' }}</div>-->
                    </div>
                  </div>

                  <div class="record-actions">
                    <el-button type="primary" link size="small" @click="handleView(item)">查看</el-button>
                    <el-button type="success" link size="small" @click="handleDownload(item)">下载</el-button>
                  </div>
                </div>
            </div>
            <div v-else class="record-empty">暂无案件笔录记录</div>
        </el-scrollbar>

        <el-dialog :visible.sync="viewVisible" title="查看笔录" width="560px" append-to-body>
            <el-descriptions v-if="currentRecord" :column="1" border>
                <el-descriptions-item label="笔录类型">{{ currentRecord.typeName || '-' }}</el-descriptions-item>
<!--                <el-descriptions-item label="被调查人">{{ currentRecord.respondentName || '-' }}</el-descriptions-item>-->
<!--                <el-descriptions-item label="调查时间">{{ currentRecord.surveyTime || '-' }}</el-descriptions-item>-->
<!--                <el-descriptions-item label="调查地点">{{ currentRecord.surveyAddress || '-' }}</el-descriptions-item>-->
<!--                <el-descriptions-item label="标题">{{ currentRecord.title || '-' }}</el-descriptions-item>-->
                <el-descriptions-item label="备注说明">{{ currentRecord.descr || '-' }}</el-descriptions-item>
                <el-descriptions-item label="上传时间">{{ currentRecord.surveyTime || '-' }}</el-descriptions-item>
            </el-descriptions>
            <template #footer>
                <el-button @click="viewVisible = false">关闭</el-button>
                <el-button type="primary" @click="handleDownload(currentRecord); viewVisible = false">下载文件</el-button>
            </template>
        </el-dialog>
    </div>
</template>

<script>
import {getTranscriptRecordList} from '@/api/recognition/survey'
export default {
    name: 'TranscriptRecordList',
    data() {
        return {
            recordLoading: false,
            recordList: [],
            viewVisible: false,
            currentRecord: null
        }
    },
    created() {
        // this.loadRecordList();
        this.getTranscriptRecordList();
    },
    methods: {
        loadRecordList() {
            this.recordLoading = true
            setTimeout(() => {
                this.recordList = []
                this.recordLoading = false
            }, 200)
        },
        handleView(item) {
            this.currentRecord = item
            this.viewVisible = true
        },
        handleDownload(item) {
          let arr=this.formatFile(item.fileUrl) || []
          if (!arr || arr?.length<=0) {
                this.$message.warning('暂无文件地址')
                return
            }
            arr.forEach(item=>{
              const url = item.url.startsWith('http') ? item.url : (this.imageUrlprefix || '') + item.url
              window.open(url, '_blank')
            })
        },
        handleDelete(item) {
            this.$confirm('确认删除该笔录记录？', '提示', { type: 'warning' })
                .then(() => {
                    this.recordList = this.recordList.filter((r) => (r.id || r) !== (item.id || item))
                    this.$message.success('删除成功')
                })
                .catch(() => {})
        },
    //   获取笔录记录列表
        getTranscriptRecordList() {
          let id = this.$route.query.id || ''
          if (!id)return;
            getTranscriptRecordList({
                caseId: id
            }).then((res) => {
                if (res.code === 200) {
                    this.recordList = res.data || []
                }
            })
        },
      formatFile(url){
          if(!url)return[]
          let arr = url.split(',')
          let fileList= arr.map(item=>{
            return {
                name:item.split('/').pop(),
                url:item
            }
          })
        return fileList
      }
    }
}
</script>

<style lang="scss" scoped>
.section-block {
    margin-bottom: 24px;
    background: #fff;
    border-radius: 4px;
    padding: 20px;

    .section-title {
        position: relative;
        font-size: 14px;
        font-weight: 500;
        color: #303133;
        padding-left: 11px;
        margin-bottom: 12px;

        &::before {
            content: '';
            position: absolute;
            left: 0;
            top: 50%;
            transform: translateY(-50%);
            width: 3px;
            height: 12px;
            border-radius: 20px;
            background: var(--vt-c-blue);
        }
    }
}

.record-block .section-title {
    flex-shrink: 0;
}

.record-scrollbar {
    min-height: 200px;
    max-height: 320px;

    :deep(.el-scrollbar__wrap) {
        overflow-x: hidden;
    }
}

.record-list {
    display: flex;
    flex-direction: column;
    gap: 12px;
}

.record-item {
    display: flex;
    align-items: flex-start;
    gap: 12px;
    padding: 12px;
    background: #fafafa;
    border-radius: 4px;
    border: 1px solid #ebeef5;
}

.record-icon-wrap {
    flex-shrink: 0;
    width: 48px;
    height: 48px;
}

.record-icon {
    width: 100%;
    height: 100%;
    object-fit: contain;
}
.record-content{
  flex: 1;
  display: flex;
  flex-flow: column;
}
.record-body {
    flex: 1;
    min-width: 0;
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 12px;
  padding-right: 20px;
  color: rgba(119, 129, 148, 1);
  font-family: "Alibaba PuHuiTi 3.0";
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
}

.record-title {
    font-weight: 500;
    color: #303133;
    font-size: 14px;
    margin-bottom: 6px;
}

.record-remark {
    font-size: 13px;
    color: #606266;
    line-height: 1.5;
    margin-bottom: 8px;
}

.record-actions {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 12px;
  .el-button{
    margin-left: 0px;
    border-radius: 4px;
    padding: 6px 15px;
  }
}

.record-empty {
    text-align: center;
    color: #909399;
    padding: 60px 0;
    font-size: 14px;
}
.record-block{
  padding-left: 0px;
  padding-top: 0px;
}
</style>
